import React from 'react';
import './WorldNode.css';

function WorldNode({ node, isSelected, onClick }) {
    const getNodeTypeClass = () => {
        switch (node.type) {
            case 'lesson': return 'lesson-node';
            case 'mini_game': return 'game-node';
            case 'boss': return 'boss-node';
            default: return '';
        }
    };

    const getStatusClass = () => {
        if (node.completed) return 'completed';
        if (node.unlocked) return 'unlocked';
        return 'locked';
    };

    return (
        <div
            className={`world-node ${getNodeTypeClass()} ${getStatusClass()} ${isSelected ? 'selected' : ''}`}
            style={{
                left: node.position.x,
                top: node.position.y
            }}
            onClick={onClick}
        >
            {/* Glow effect for unlocked nodes */}
            {node.unlocked && !node.completed && (
                <div className="node-glow" />
            )}

            {/* Node circle */}
            <div className="node-circle">
                <span className="node-icon">{node.icon}</span>

                {/* Completion checkmark */}
                {node.completed && (
                    <div className="completion-badge">✓</div>
                )}

                {/* Lock icon for locked nodes */}
                {!node.unlocked && (
                    <div className="lock-overlay">🔒</div>
                )}
            </div>

            {/* Stars display */}
            {node.completed && (
                <div className="node-stars">
                    {[1, 2, 3].map(star => (
                        <span
                            key={star}
                            className={`mini-star ${star <= node.stars ? 'earned' : ''}`}
                        >
                            ★
                        </span>
                    ))}
                </div>
            )}

            {/* Node label */}
            <div className="node-label">
                <span className="node-title">{node.title}</span>
                <span className="node-xp">+{node.xpReward} XP</span>
            </div>

            {/* Pulse animation for current target */}
            {node.unlocked && !node.completed && (
                <div className="pulse-ring" />
            )}
        </div>
    );
}

export default WorldNode;
